import { StudentUsersUIProvider } from "./StudentUsersUIContext";
import { StudentUsersCard } from "./StudentUsersCard";

export function StudentUsersPage({
  history,
  userGroupId,
  userType
}) {
  return (
    <StudentUsersUIProvider>
      <StudentUsersCard
        history={history}
        userGroupId={userGroupId}
        userType={userType}
      />
    </StudentUsersUIProvider>
 );
}